import * as React from 'react';
import { useDeviceType } from '@cian/ui-kit';
import { PhoneButtonDesktop, PhoneButtonMobile } from '../../components/PhoneButton';
import { formatPhone } from '../../utils/formatters';

export interface IPhoneButtonContainerProps {
  phone: string;
  onShow?(): void;
}

export const PhoneButtonContainer: React.FC<IPhoneButtonContainerProps> = ({ phone, onShow }) => {
  const [phoneVisible, setPhoneVisible] = React.useState(false);
  const deviceType = useDeviceType();
  const formattedPhone = React.useMemo(() => {
    return formatPhone(phone);
  }, [phone]);
  const collapsedPhone = `${formattedPhone.slice(0, -2)}...`;

  const handleShowPhone = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();

      setPhoneVisible(true);

      if (onShow) {
        onShow();
      }
    },
    [onShow],
  );

  const PhoneButtonComponent = deviceType === 'desktop' ? PhoneButtonDesktop : PhoneButtonMobile;

  return (
    <PhoneButtonComponent
      phone={formattedPhone}
      collapsedPhone={collapsedPhone}
      phoneVisible={phoneVisible}
      onClick={handleShowPhone}
    />
  );
};
